import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useTranslation } from "react-i18next";

export const ContestAgreementsMissingToken = () => {
  const { t } = useTranslation();
  return (
    <div className="space-2">
      <Alert>
        <AlertTitle>{t("contestAgreements.missingToken.title")}</AlertTitle>
        <AlertDescription>
          {t("contestAgreements.missingToken.description")}
        </AlertDescription>
      </Alert>
    </div>
  );
};
